import { Head } from "@inertiajs/react"
import { PublicShell } from "@/components/PublicShell"

type Props = {
  title: string
  description: string
  lastUpdated: string
  children: React.ReactNode
}

/**
 * Shared shell for the Privacy, Terms and Data Deletion pages.
 *
 * Centralises the four meta tags CLAUDE.md requires on every page so the
 * three legal pages cannot drift apart, and keeps the prose to bare semantic
 * HTML — headings, paragraphs and lists are already styled by the base layer
 * in design-system.css, so no text utilities are applied on top.
 */
export function LegalPage({ title, description, lastUpdated, children }: Props) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      <PublicShell>
        <article className="max-w-3xl mx-auto py-4 space-y-8">
          <header className="space-y-2">
            <h1>{title}</h1>
            <p className="text-sm text-ink-muted">Last updated {lastUpdated}</p>
          </header>
          {/* break-words so the long contact address (an unbreakable 33-char
              token) cannot push the page sideways on a narrow phone. */}
          <div className="space-y-8 break-words [&_h2]:mb-3 [&_p]:mb-4 [&_ul]:mb-4 [&_ul]:space-y-2 [&_ul]:list-disc [&_ul]:pl-6 [&_section>*:last-child]:mb-0">
            {children}
          </div>
        </article>
      </PublicShell>
    </>
  )
}
